"use strict";
export const initMarquee = async (selector, functionToCall = null) => {
    const firstElement = document.querySelector(selector);
    if (!firstElement) return;
	try {
        const module = await import('../modules/marquee');
        module.initMarquee(selector, functionToCall);
	} catch (error) {
		console.error("Failed to load Marquee dynamically:", error);
		return;
	}
}